import { SHORT_DATE_FORMAT } from "./date-utils";
export function normalizeTitle(localizeFrom, value_localization, data, formatDate){
	const localized = localizeFrom(value_localization, data);
	if(localized) return localized;
	if(typeof data === "string" && isISODateTimeString(data)) return formatDate(data, SHORT_DATE_FORMAT);
	return data || "";
}

function isISODateTimeString(str){
	// Check for ISO 8601 date/time format: YYYY-MM-DDTHH:MM:SS.sssZ or YYYY-MM-DDTHH:MM:SSZ
	const isoDateTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z?$/;
	return isoDateTimeRegex.test(str) && !isNaN(Date.parse(str));
}

export function getValueLocalization(schema){
	if(schema.type === "array")
		return (schema.items || {}).value_localization || (schema.items || {}).valueLocalization || {};
	else
		return schema.value_localization || schema.valueLocalization || {};
}